import icdm2025logosmall from "../assets/workshopRelated/icdm2025logosmall.png";
const events = [
  // {

  // },
  {
    title: "Workshop on Trustworthy Machine Learning for Fair, Private, Robust, and Explainable Decision-Making (TML4DM) 2026",
    _type: "Commencing",
    // no space!
    _destination_id: "icdm-workshop-2026",
    post_time: "May 21, 2026",
    time_zone: "AEST",
    typeColorRgb: "0, 128, 0",
    subtitle: "Co-located with 26th IEEE International Conference on Data Mining (ICDM 2026)",
    image:
      icdm2025logosmall,
    show: true
  },

  {
    title: "Workshop on Trustworthy Machine Learning for Fair, Private, Robust, and Explainable Decision-Making 2025",
    _type: "Past",
    // no space!
    _destination_id: "icdm-workshop-2025",
    post_time: "November 12, 2025",
    time_zone: "AEST",
    typeColorRgb: "92, 92, 92",
    subtitle: "Co-located with 25th IEEE International Conference on Data Mining (ICDM 2025)",
    image:
      icdm2025logosmall,
    show: true
  },
  

];

export default events;
